import script from "./home.vue?vue&type=script&setup=true&lang=ts"
export * from "./home.vue?vue&type=script&setup=true&lang=ts"

import "./home.vue?vue&type=style&index=0&id=142473b6&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-142473b6"]])

export default __exports__